import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Box, Group, Image, Text } from '@mantine/core';
export const FavoriteGameCard: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Group gap={20} align="center">
      <Image src="/assets/info/game_2.png" w={69} h={69} alt="game-info" />
      <Box>
        <Text fz={{
        base: 14,
        sm: 18
      }} className={gunterzBold.className} tt="uppercase">
          {i18n._('FAVORITE GAME')}
        </Text>
        <Text fz="xs" c="var(--text-prime)" tt="uppercase">
          {i18n._('FRUIT PARTY')}
        </Text>
        <Text fz="xs" c="var(--text-dark)" tt="capitalize">
          {i18n._('Pragmatic Play')}
        </Text>
      </Box>
    </Group>;
};